import React, { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Header({ activePage = null }) {
	const navigate = useNavigate();;
	const { i18n, t } = useTranslation();

	const onChangeLang = (lang) => {
		i18n.changeLanguage(lang);
	};

	return (
		<header >
			<div className="header_container">
				<div className="logo">
					<a href="#">
						<img src="/assets/images/logo.svg" alt="" />
					</a>
				</div>
				<div className="menu">
					<div className="menu_item">
						<a href="#about_us">{t("about_us")}</a>
					</div>
					<div className="menu_item">
						<a href="#contact" >{t("contact")}</a>
					</div>
				</div>
				<div className="header_right_cubes">
					<div className="language" onClick={() => onChangeLang(i18n.language == 'ka' ? 'en' : 'ka')}>
						{ i18n.language == 'ka' ? 'Eng' : 'ქარ' } <img src="/assets/images/globe.png" alt="" />
					</div>
					<img src="/assets/images/header_cubes.png" alt="" />
				</div>
			</div>
			<div className="header_container_sm">
				<div className="sm_bar">
				</div>
				<div className="logo">
					<a href="#">
						<img src="/assets/images/logo.svg" alt="" />
					</a>
				</div>
				
				<div className="header_right_cubes">
					<div className="language" onClick={() => onChangeLang(i18n.language == 'ka' ? 'en' : 'ka')}>
						{ i18n.language == 'ka' ? 'Eng' : 'ქარ' } <img src="/assets/images/globe.png" alt="" />
					</div>
				</div>
			</div>
		</header>
	);
}
